module.exports = __webpack_public_path__ + "static/media/mlt.159b0e1b.svg";